<template>
  <div class="tabs side-panel-right-field">
    <div class="d-flex container mb-2 mb-sm-2 pa-0">
      <div class="mr-1 d-flex container__tab">
        <TabButton thisTab="1" :currentTab="tab" @tab-change="handleClick">Все продукты</TabButton>
        <TabButton thisTab="2" :currentTab="tab" @tab-change="handleClick">Регистрация бизнеса</TabButton>
        <TabButton v-if="canSeeAutoCreditTab" thisTab="3" :currentTab="tab" @tab-change="handleClick">Регистрация ИП патент</TabButton>
        <!-- <TabButton thisTab="3" :currentTab="tab" @tab-change="handleClick">Кредит под залог недвижимости</TabButton>-->
      </div>
    </div>
    <div class="d-flex mb-2">
      <!-- <v-btn
        class="container__btn"
        small
        outlined
        :href="`https://modulbank.ru/kzn/?utm_source=agentnet&utm_medium=partner&utm_campaign=KZN_ag-${innLink}`"
        target="_blank"
      >
        Кредит под залог недвижимости
      </v-btn> -->
      <!-- TODO: УДАЛИТЬ ЧЕРЕЗ ГОД - 15.01.2025 -->
      <!-- <v-btn
        class="container__btn"
        small
        outlined
        :href="`https://modulbank.ru/garantii//?utm_source=agentnet&utm_medium=partner&utm_campaign=BG_ag-${innLink}`"
        target="_blank"
        >Банковская гарантия
      </v-btn> -->
    </div>
    <div class="mb-8">
      <NewBidAllProduct v-show="tab === '1'" />
      <NewBidRegBusiness v-show="tab === '2'" />
      <NewBidAutocredit v-show="tab === '3'" />
    </div>
  </div>
</template>

<script>
import TabButton from "@/components/common/TabButton";
import NewBidAllProduct from "@/components/bids/NewBidAllProduct";
import NewBidRegBusiness from "@/components/bids/NewBidRegBusiness";
import NewBidAutocredit from "@/components/bids/NewBidAutocredit";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    TabButton,
    NewBidAllProduct,
    NewBidRegBusiness,
    NewBidAutocredit,
  },

  computed: {
    ...mapState("bid", ["tab"]),
    ...mapState("profile", ["inn", "company"]),
    ...mapGetters("profile", ["canSeeAutoCreditTab"]),

    innLink() {
      if (this.company && this.company.inn) {
        return this.company.inn;
      }
      if (this.inn) {
        return this.inn;
      } else {
        return;
      }
    },
  },
  methods: {
    handleClick(value) {
      if (value === "4")
        window.open(
          `https://modulbank.ru/kzn/?utm_source=agentnet&utm_medium=partner&utm_campaign=KZN_ag-${this.innLink}`
        );
      else this.$store.commit("bid/set", { type: "tab", value });
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-bottom: 40px;

  &__btn {
    padding: 14px 16px;
    border: 1px solid #cbcdd1;
    cursor: pointer;
  }

  &__btn--active {
    background: #f2f6ff;
    border: 2px solid #4971d0;
  }
}

.note {
  background: #e36868;
  border-radius: 3px;
  padding: 14px 20px;
}

.container {
  display: flex;
  @media (max-width: 690px) {
    flex-wrap: wrap;
  }

  &__tab {
    @media (max-width: 690px) {
      margin-bottom: 10px;
    }
  }

  &__btn {
    min-height: 54px;
    text-transform: initial;
    @media (max-width: 360px) {
      min-height: 42px;
    }
  }
}

.container__btn {
  font-weight: 400;
  letter-spacing: unset;
  font-size: 16px;
  border: 1px solid #cbcdd1;
  border-radius: 0%;
}
</style>
